import React from "react";
import { CounterpartyDisabledFilter } from "@common/constants/counterparty";
import { Radio, RadioGroup } from "@design-system/Radio/Radio";
import { BaseFilterProps } from "../../lib";
import styles from "./DisabledCounterpartyFilter.module.scss";

const options: Array<{ value: CounterpartyDisabledFilter; label: string }> = [
    { value: CounterpartyDisabledFilter.ALL, label: "All" },
    { value: CounterpartyDisabledFilter.ONLY_ENABLED, label: "Only enabled" },
    {
        value: CounterpartyDisabledFilter.ONLY_DISABLED,
        label: "Only disabled",
    },
];

export const DisabledCounterpartyFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => (
    <div className={styles.filter}>
        <RadioGroup<CounterpartyDisabledFilter>
            name="disabledFilter"
            aria-label="disabledFilter"
            value={filters.disabledFilter ?? CounterpartyDisabledFilter.ALL}
            onValueChange={(disabledFilter) =>
                onChange({
                    disabledFilter:
                        disabledFilter === CounterpartyDisabledFilter.ALL
                            ? undefined
                            : disabledFilter,
                })
            }
            className={styles.radioGroup}
        >
            {options.map((option) => (
                <Radio
                    key={option.value}
                    value={option.value}
                    label={option.label}
                />
            ))}
        </RadioGroup>
    </div>
);
